import { render, staticRenderFns } from "./SupprimeDocumentDialog.vue?vue&type=template&id=fe6b0480&"
import script from "./SupprimeDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./SupprimeDocumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports